import COLORS from "../../config/colors";

export default function AddEmployeeModal({
  show, onClose, onCreate, form, setForm, styles,
}) {
  if (!show) return null;

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: COLORS.white, borderRadius: 16, padding: 32, width: 400, boxShadow: "0 12px 40px rgba(0,0,0,0.15)" }}>
        <h3 style={styles.sectionTitle}>Add Crew Member</h3>
        <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 16 }}>
          <div><label style={styles.label}>Name</label><input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={styles.input} placeholder="Jake Rivera" /></div>
          <div><label style={styles.label}>Phone (for SMS time tracking)</label><input value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} style={styles.input} placeholder="(530) 555-0000" /></div>
          <div><label style={styles.label}>Email</label><input value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} style={styles.input} placeholder="jake@email.com" /></div>
          <div><label style={styles.label}>Hourly Rate</label><input type="number" value={form.hourly_rate} onChange={e => setForm(f => ({ ...f, hourly_rate: e.target.value }))} style={styles.input} placeholder="35" /></div>
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <button onClick={onClose} style={styles.secondaryBtn}>Cancel</button>
          <button onClick={onCreate} disabled={!form.name} style={{ ...styles.primaryBtn, flex: 1, opacity: form.name ? 1 : 0.6 }}>Add Employee</button>
        </div>
        <p style={{ fontSize: 11, color: COLORS.stone, marginTop: 12, lineHeight: 1.5 }}>
          Once added, they'll get auto-text reminders at 4pm asking what they worked on. They can reply by text and it logs automatically.
        </p>
      </div>
    </div>
  );
}
